import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormikProps } from 'formik'

import FieldLabelWrapperComponent from '../../../../../../../features/components/Form/FieldLabelWrapper'
import FieldComponent from '../../../../../../../components/Form/Field'

import { container, facebookFieldWrapper, tikTokFieldWrapper } from './styles.css'
import { useSelector } from 'react-redux'
import {
  selectedFacebookAdAccountSelector,
  selectedTikTokAdAccountSelector
} from '../../../../../../../modules/selectors/adAccounts'

const FieldLabelWrapper = FieldLabelWrapperComponent as any
const Field = FieldComponent as any

interface FacebookAndTikTokBudgetFieldsProps {
  formik: FormikProps<any>
}

const FacebookAndTikTokBudgetFields: React.FC<FacebookAndTikTokBudgetFieldsProps> = ({ formik }) => {
  const { t } = useTranslation()

  const { currency_symbol: facebookCurrencySymbol } = useSelector(selectedFacebookAdAccountSelector)
  const { currency_symbol: tiktokCurrencySymbol } = useSelector(selectedTikTokAdAccountSelector)

  return (
    <div className={container}>
      <FieldLabelWrapper label={t('Meta')} className={facebookFieldWrapper}>
        <Field
          formik={formik}
          id={'BUDGET_FACEBOOK'}
          name={'BUDGET_FACEBOOK'}
          placeholder="Budget"
          symbol={facebookCurrencySymbol}
        />
      </FieldLabelWrapper>
      <FieldLabelWrapper label={t('TikTok')} className={tikTokFieldWrapper}>
        <Field
          formik={formik}
          id={'BUDGET_TIKTOK'}
          name={'BUDGET_TIKTOK'}
          placeholder="Budget"
          symbol={tiktokCurrencySymbol}
        />
      </FieldLabelWrapper>
    </div>
  )
}

export default FacebookAndTikTokBudgetFields
